import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify';
import store from './store'
import globalMixin from './mixins/global'
import './plugins/axios';
import './plugins/toasted';

// グローバルmixinを導入
Vue.mixin(globalMixin)

Vue.config.productionTip = false

Vue.config.errorHandler = (err, vm, info) => {
  // ログアウト処理が走っただけの時はloadingを閉じるだけであとは何もしない
  if (err === 'signOut') {
    vm.$app.$refs.loading.close()
    return
  }
  // 401, 422のエラーは何もしない。
  // axiosのエラーで発生するもので、axios側で処理するから
  if (err.response && [401, 422].includes(err.response.status)) return

  // navigation guard内でリダイレクトするとエラーになるがひとまず握り潰す。
  if (err.message.includes('Redirected when going') && err.message.includes('via a navigation guard')) return

  // 401, 422以外のエラーはエラー画面へ遷移させる
  if (router.history.current.name !== 'Error') {
    router.push({ name: 'Error', params: { err: err, info: info} })
  }
};

new Vue({
  router,
  vuetify,
  store,
  render: h => h(App)
}).$mount('#app')
